import { Wordmark } from "./Nav";
import { WHATSAPP_LINK, WHATSAPP_NUMBER, PHONE_SECONDARY, EMAIL, SOCIAL_LINKS, NAV_LINKS } from "../../data/content";

const Footer = () => (
    <footer className="bg-navy border-t border-white/10 pt-16 pb-28 md:pb-10" data-testid="site-footer">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
            <div className="grid md:grid-cols-4 gap-10">
                <div className="md:col-span-2">
                    <Wordmark dark />
                    <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/50">
                        From lead generation to revenue automation, done for you. A founder-led AI growth agency
                        from Ludhiana, Punjab, India.
                    </p>
                </div>

                <div>
                    <p className="text-xs font-semibold uppercase tracking-[0.25em] text-white/40 mb-5">Contact</p>
                    <ul className="space-y-3 text-sm">
                        <li>
                            <a
                                href={WHATSAPP_LINK}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-whatsapp-link"
                                className="text-white/80 hover:text-accent transition-colors duration-200"
                            >
                                WhatsApp {WHATSAPP_NUMBER}
                            </a>
                        </li>
                        <li>
                            <a
                                href={`tel:${PHONE_SECONDARY.replace(/\s/g, "")}`}
                                data-testid="footer-phone-link"
                                className="text-white/80 hover:text-accent transition-colors duration-200"
                            >
                                Call {PHONE_SECONDARY}
                            </a>
                        </li>
                        <li>
                            <a
                                href={`mailto:${EMAIL}`}
                                data-testid="footer-email"
                                className="text-white/80 hover:text-accent transition-colors duration-200"
                            >
                                {EMAIL}
                            </a>
                        </li>
                        <li className="text-white/40">Ludhiana, Punjab, India</li>
                    </ul>
                </div>

                <div>
                    <p className="text-xs font-semibold uppercase tracking-[0.25em] text-white/40 mb-5">Elsewhere</p>
                    <ul className="space-y-3 text-sm">
                        {SOCIAL_LINKS.map((s) => (
                            <li key={s.label}>
                                <a
                                    href={s.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                                    className="text-white/80 hover:text-accent transition-colors duration-200"
                                >
                                    {s.label}
                                </a>
                            </li>
                        ))}
                        <li>
                            <a href="https://chatproz.com" target="_blank" rel="noopener noreferrer" data-testid="footer-chatproz-link" className="text-white/80 hover:text-accent transition-colors duration-200">
                                chatproz.com
                            </a>
                        </li>
                        <li>
                            <a href="https://kuunalpruuthi.com" target="_blank" rel="noopener noreferrer" data-testid="footer-kuunal-link" className="text-white/80 hover:text-accent transition-colors duration-200">
                                kuunalpruuthi.com
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                <p className="text-xs text-white/40">© 2026 ChatProz. All rights reserved.</p>
                <nav className="flex flex-wrap gap-6" aria-label="Footer">
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="text-xs text-white/50 hover:text-white transition-colors duration-200"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
            </div>
        </div>
    </footer>
);

export default Footer;
